'use client';
import { MonitorMediaFilterType } from '@mnd-frontend/graphql-schema';
import { Icons } from '@mnd-frontend/ui/publish/components';
import { GREY_900, SIZING_1_5 } from '@mnd-frontend/ui/shared/tokens';
import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  gap: 4px;
  align-items: end;
`;

const Name = styled.span<{ $compact: boolean }>`
  font-size: ${props => (props.$compact ? SIZING_1_5 : '0.875rem')};
  line-height: 1;
  color: ${GREY_900};
  font-weight: 500;
`;

type MediaTypeProps = {
  id: MonitorMediaFilterType;
  name: string;
  compact: boolean;
};

const getMediaTypeIcon = (mediaType: MonitorMediaFilterType): React.ComponentType<any> | null => {
  switch (mediaType) {
    case MonitorMediaFilterType.Ether:
      return Icons.Radio;
    case MonitorMediaFilterType.Podcast:
      return Icons.Podcast;
    case MonitorMediaFilterType.Print:
      return Icons.Story;
    case MonitorMediaFilterType.Radio:
      return Icons.Radio;
    case MonitorMediaFilterType.Tv:
      return Icons.TV;
    case MonitorMediaFilterType.TvPlay:
      return Icons.LearningVideo;
    case MonitorMediaFilterType.TvWeb:
      return Icons.TvWeb;
    case MonitorMediaFilterType.Youtube:
      return Icons.Youtube;
    case MonitorMediaFilterType.Facebook:
      return Icons.Facebook;
    case MonitorMediaFilterType.Twitter:
      return Icons.X;
    case MonitorMediaFilterType.Instagram:
      return Icons.Instagram;
    case MonitorMediaFilterType.Linkedin:
      return Icons.LinkedIn;
    case MonitorMediaFilterType.Web:
      return Icons.Story;
    case MonitorMediaFilterType.Blogs:
      return Icons.Blog;
    case MonitorMediaFilterType.Forums:
      return Icons.Forum;
    case MonitorMediaFilterType.SocialMedia:
      return Icons.SocialMedia;
    case MonitorMediaFilterType.Tiktok:
      return Icons.Tiktok;
    default:
      return null;
  }
};

const MediaType = ({ id, name, compact }: MediaTypeProps) => {
  const Icon = getMediaTypeIcon(id);
  if (!Icon) return null;

  return (
    <Container>
      <Icon $color="colorIconsDefault" $size={compact ? 'xxxs' : 'xxs'} />
      <Name $compact={compact}>{name}</Name>
    </Container>
  );
};

export default MediaType;
